export const shortAddress = (address: string): string => {
  const parts = address.split(/,\s*/);
  return parts.slice(0, 2).join(', ');
};
